import React from 'react';
import Link from '../link';
import Button from '../button';

interface Props {
  signup?: boolean;
  text?: string;
}

const AccountPrompt: React.FC<Props> = ({ signup = true, text }) => {
  return (
    <div>
      <p>
        {text ?? 'Please sign in or create an account to access this page.'}
      </p>
      <Link href="/account/signin">
        <Button text="Sign In" />
      </Link>{' '}
      {signup && (
        <Link href="/account/signup">
          <Button text="Create Account" />
        </Link>
      )}
    </div>
  );
};

export default AccountPrompt;
